import React from "react";
import "./stlyes.scss";
import { Modal, Spinner } from "react-bootstrap";
import { ReactComponent as ShareIcon } from "../../../public/post-icons/share-icon.svg";
import ProfilePicture from "../../App/shared/ProfilePicture";
import { getCurrentUser } from "../../../api/helper";
import PostAttachments from "../../App/PostsList/Post/PostBody/PostAttachments";
import HvButton from "../../App/shared/HvButton";
import { createPost } from "../../../api/posts";
import { log_error } from "../../../api";
import PlusIcon from "../../shared/Svg/PlusIcon";

export default class SharingModal extends React.Component {
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });
  handleClick = e =>
    this.hocWrapper.current.contains(e.target) && this.handleShow();
  componentDidMount = () =>
    document.body.addEventListener("click", this.handleClick);
  componentWillUnmount = () =>
    document.body.removeEventListener("click", this.handleClick);
  textSetter = e =>
    this.setState({
      body: { ...this.state.body, text: e.target.value}
    });
  createPostHandler = async () => {
    if (!this.state.body.text) return;
    try {
      this.setState({ isLoading: true });
      await createPost({
        post: {
          text: this.state.body.text,
          reshareable_type: this.state.body.reshareable_type,
          reshareable_id: this.state.body.reshareable_id,
          attachments: this.state.body.attachments.map(a => ({
            id: a.id,
            type: a.type
          }))
        }
      });
      await this.setState(this.init_state);
      this.props.onSubmit();
    } catch (error) {
      log_error(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };
  init_state = {
    isLoading: false,
    show: false,
    body: {
      attachments: this.props.attachments,
      text: this.props.text,
      reshareable_type: this.props.attachments[0]["type"],
      reshareable_id: this.props.attachments[0]["id"]
    }
  };
  state = this.init_state;
  hocWrapper = React.createRef();
  render() {
    return (
      <>
        <div ref={this.hocWrapper} className="hor_click">
          {this.props.children}
        </div>
        <Modal
          id="sharing-modal"
          show={this.state.show}
          onHide={this.handleClose}
        >
          <Modal.Body className="tweet-box">
            <div className="media mb-2">
              <ShareIcon className="mr-2" />
              <small className="text-uppercase text-primary">repost</small>
            </div>
            <div className="media m-3">
              <ProfilePicture className="mr-3" user={getCurrentUser()} />
              <textarea
                className="tweet-area pt-2"
                rows={3}
                onChange={this.textSetter}
                placeholder="Write text for repost..."
                value={this.state.body.text}
              />
            </div>
            <PostAttachments attachments={this.state.body.attachments} />
            <div className="text-right">
              <HvButton
                type="button"
                id="create-post"
                className="btn bg-white text-primary btn-md mt-3 mt-md-0"
                onClick={this.createPostHandler}
              >
                {this.state.isLoading ? (
                  <Spinner animation="border" variant="primary" role="status" />
                ) : (
                  <>
                    {" "}
                    <PlusIcon color="#cf2d77" className="mr-3" /> post{" "}
                  </>
                )}
              </HvButton>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
